import { Formik } from "formik";
import { Col, Form, Row } from "react-bootstrap";
import CustomEditor5 from "../../../../utils/ckEditor5";
import React, { useRef } from "react";
import { positiveNumber } from "../../../../utils/validations";
import { TiDelete } from "react-icons/ti";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Alert from "@mui/material/Alert";
import { clearCountryContentDetail } from "../../../../../store/slices/country";
import SaveAndSaveNext from "../../../utils/saveAndSaveNext";

const ContentDetailForm = (props) => {
  const firstErrorRef = useRef(null);
  const dispatch = useDispatch();
  const {
    putCountryContentDetailError,
    message,
    putCountryContentDetailLoading,
  } = useSelector((state) => state.cmsCountry);
  useEffect(() => {
    if (message) {
      setTimeout(() => {
        dispatch(clearCountryContentDetail());
      }, 5000);
    }
  }, [message]);
  return (
    <div>
      <div className={"notification_popup"}>
        {message && (
          <Alert severity={putCountryContentDetailError ? `error` : `success`}>
            {" "}
            {message}
          </Alert>
        )}
      </div>

      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        validate={(values) => {
          const errors = {};
          if (
            !/^(?!0$)\d+(\.\d{1,2})?$/.test(values.min_wage) &&
            values.min_wage
          ) {
            errors.min_wage =
              "Ensure that there are no more than 2 digits after decimal";
          }
          if (
            values.country_guide &&
            values.country_guide.size >= 15 * 1024 * 1024
          ) {
            errors.country_guide = "Minimum size of pdf is 15mb";
          }
          if (
            values.college_guide &&
            values.college_guide.size >= 15 * 1024 * 1024
          ) {
            errors.college_guide = "Minimum size of pdf is 15mb";
          }
          if (
            values.course_guide &&
            values.course_guide.size >= 15 * 1024 * 1024
          ) {
            errors.course_guide = "Minimum size of pdf is 15mb";
          }
          if (values?.max_hours) {
            if (!/^[1-9]\d*$/.test(values?.max_hours)) {
              errors.max_hours = "Must be an positive integers without zero";
            }
          }
          if (values.about_the_country.length > 0) {
            if (values.about_the_country.trim().split(/\s+/).length < 250) {
              errors.about_the_country = `Please enter minimum 250 words`;
            } else if (values.about_the_country.trim().split(/\s+/).length > 500) {
              errors.about_the_country = `Word limit Exceeded please enter only 500 words
              ${500 - values.about_the_country.trim().split(/\s+/).length}`;
            }
          }
          if (values.why_study.length > 0) {
            if (values.why_study.trim().split(/\s+/).length < 250) {
              errors.why_study = `Please enter minimum 250 words`;
            } else if (values.why_study.trim().split(/\s+/).length > 500) {
              errors.why_study = `Word limit Exceeded please enter only 500 words
              ${500 - values.why_study.trim().split(/\s+/).length}`;
            }
          }
          if (values.scholarship.length > 0) {
            if (values.scholarship.trim().split(/\s+/).length < 250) {
              errors.scholarship = `Please enter minimum 250 words`;
            } else if (values.scholarship.trim().split(/\s+/).length > 500) {
              errors.scholarship = `Word limit Exceeded please enter only 500 words
              ${500 - values.scholarship.trim().split(/\s+/).length}`;
            }
          }
          if (values.student_visa.length > 0) {
            if (values.student_visa.trim().split(/\s+/).length < 250) {
              errors.student_visa = `Please enter minimum 250 words`;
            } else if (values.student_visa.trim().split(/\s+/).length > 500) {
              errors.student_visa = `Word limit Exceeded please enter only 500 words
              ${500 - values.student_visa.trim().split(/\s+/).length}`;
            }
          }
          if (values.lor.length > 0) {
            if (values.lor.trim().split(/\s+/).length < 250) {
              errors.lor = `Please enter minimum 250 words`;
            } else if (values.lor.trim().split(/\s+/).length > 500) {
              errors.lor = `Word limit Exceeded please enter only 500 words
              ${500 - values.lor.trim().split(/\s+/).length}`;
            }
          }
          if (values.sop.length > 0) {
            if (values.sop.trim().split(/\s+/).length < 250) {
              errors.sop = `Please enter minimum 250 words`;
            } else if (values.sop.trim().split(/\s+/).length > 500) {
              errors.sop = `Word limit Exceeded please enter only 500 words
              ${500 - values.sop.trim().split(/\s+/).length}`;
            }
          }
          if (values.application.length > 0) {
            if (values.application.trim().split(/\s+/).length < 250) {
              errors.application = `Please enter minimum 250 words`;
            } else if (values.application.trim().split(/\s+/).length > 500) {
              errors.application = `Word limit Exceeded please enter only 500 words
              ${500 - values.application.trim().split(/\s+/).length}`;
            }
          }
          if (values.document.length > 0) {
            if (values.document.trim().split(/\s+/).length < 100) {
              errors.document = `Please enter minimum 100 words`;
            } else if (values.document.trim().split(/\s+/).length > 500) {
              errors.document = `Word limit Exceeded please enter only 500 words
              ${500 - values.document.trim().split(/\s+/).length}`;
            }
          }
          if (values.part_time_work.length > 0) {
            if (values.part_time_work.trim().split(/\s+/).length < 100) {
              errors.part_time_work = `Please enter minimum 100 words`;
            } else if (values.part_time_work.trim().split(/\s+/).length > 500) {
              errors.part_time_work = `Word limit Exceeded please enter only 500 words
              ${500 - values.part_time_work.trim().split(/\s+/).length}`;
            }
          }
          if (values.work_permit.length > 0) {
            if (values.work_permit.trim().split(/\s+/).length < 100) {
              errors.work_permit = `Please enter minimum 100 words`;
            } else if (values.work_permit.trim().split(/\s+/).length > 500) {
              errors.work_permit = `Word limit Exceeded please enter only 500 words
              ${500 - values.work_permit.trim().split(/\s+/).length}`;
            }
          }
          Object.keys(errors).forEach((key) => {
            if (!errors[key]) {
              delete errors[key];
            }
          });
          return errors;
        }}
        onSubmit={(values) => {
          props.submit(values);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleSubmit,
          handleChange,
          handleBlur,
          setFieldValue,
          setTouched,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className={"general_information"}>
              <div className={"examfilter"}>
                <h4 className={"examfilter_heading"}>Brochure</h4>
                <Row>
                  <Col md={6}>
                    <Form.Group controlId="country_guide" className="mb-1">
                      <Form.Label>Upload Country Guide</Form.Label>
                      <Form.Control
                        type="file"
                        name="country_guide"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          // Validate if the selected file is a PDF
                          if (file && file.type === "application/pdf") {
                            setFieldValue("country_guide", file);
                          } else {
                            // Reset the value if the selected file is not a PDF
                            setFieldValue("country_guide", null);
                          }
                        }}
                        accept=".pdf"
                      />
                      {typeof values.country_guide == "string" &&
                        values.country_guide != "" && (
                          <div className="media_image_container mt-2">
                            <a href={values.country_guide} target="_blank">
                              {values.country_guide}
                            </a>
                            <span
                              className={"delete_image_btn"}
                              onClick={() => {
                                setFieldValue("country_guide", null);
                              }}
                            >
                              <TiDelete />
                            </span>
                          </div>
                        )}
                      {errors?.country_guide && touched?.country_guide && (
                        <div ref={firstErrorRef} className="error">
                          {errors?.country_guide}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="country_link">
                      <Form.Label>Link</Form.Label>
                      <Form.Control
                        type="text"
                        name="country_link"
                        className={"input_pd"}
                        value={values?.country_link}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Form.Group controlId="college_guide" className="mb-1">
                      <Form.Label>Upload College Guide</Form.Label>
                      <Form.Control
                        type="file"
                        name="college_guide"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          // Validate if the selected file is a PDF
                          if (file && file.type === "application/pdf") {
                            setFieldValue("college_guide", file);
                          } else {
                            // Reset the value if the selected file is not a PDF
                            setFieldValue("college_guide", null);
                          }
                        }}
                        accept=".pdf"
                      />
                      {typeof values.college_guide == "string" &&
                        values.college_guide != "" && (
                          <div className="media_image_container mt-2">
                            <a href={values.college_guide} target="_blank">
                              {values.college_guide}
                            </a>
                            <span
                              className={"delete_image_btn"}
                              onClick={() => {
                                setFieldValue("college_guide", null);
                              }}
                            >
                              <TiDelete />
                            </span>
                          </div>
                        )}
                      {errors?.college_guide && touched?.college_guide && (
                        <div ref={firstErrorRef} className="error">
                          {errors?.college_guide}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="college_link">
                      <Form.Label>Link</Form.Label>
                      <Form.Control
                        type="text"
                        name="college_link"
                        className={"input_pd"}
                        value={values?.college_link}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Form.Group controlId="course_guide" className="mb-1">
                      <Form.Label>Upload Course Guide</Form.Label>
                      <Form.Control
                        type="file"
                        name="course_guide"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          // Validate if the selected file is a PDF
                          if (file && file.type === "application/pdf") {
                            setFieldValue("course_guide", file);
                          } else {
                            // Reset the value if the selected file is not a PDF
                            setFieldValue("course_guide", null);
                          }
                        }}
                        accept=".pdf"
                      />
                      {typeof values.course_guide == "string" &&
                        values.course_guide != "" && (
                          <div className="media_image_container mt-2">
                            <a href={values.course_guide} target="_blank">
                              {values.course_guide}
                            </a>
                            <span
                              className={"delete_image_btn"}
                              onClick={() => {
                                setFieldValue("course_guide", null);
                              }}
                            >
                              <TiDelete />
                            </span>
                          </div>
                        )}
                      {errors?.course_guide && touched?.course_guide && (
                        <div ref={firstErrorRef} className="error">
                          {errors?.course_guide}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="course_link">
                      <Form.Label>Link</Form.Label>
                      <Form.Control
                        type="text"
                        name="course_link"
                        className={"input_pd"}
                        value={values?.course_link}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            </div>
            <div className={"basic_details_country"}>
              <Col sm={12}>
                <Form.Group className="mb-3" controlId="about_the_country">
                  <Form.Label>About {values.country_name}</Form.Label>
                  {(values.about_the_country ||
                    values.about_the_country == "undefined" ||
                    values.about_the_country == "") && (
                    <CustomEditor5
                      initData={values?.about_the_country}
                      onChange={(data) => {
                        setFieldValue("about_the_country", data);
                        if(!values.about_the_country.trim().split(/\s+/).length > 500){
                          setTouched({...touched,about_the_country:false})
                        }
                      }}
                    />
                  )}
                </Form.Group>
                {errors?.about_the_country && touched?.about_the_country && (
                  <div ref={firstErrorRef} className="error">
                    {errors?.about_the_country}
                  </div>
                )}
              </Col>
            </div>
            <div className={"basic_details_country"}>
              <Col sm={12}>
                <Form.Group className="mb-3" controlId="why_study">
                  <Form.Label>Why study in {values.country_name}</Form.Label>
                  {(values.why_study ||
                    values.why_study == "undefined" ||
                    values.why_study == "") && (
                    <CustomEditor5
                      initData={values?.why_study}
                      onChange={(data) => {
                        setFieldValue("why_study", data);
                        if(!values.why_study.trim().split(/\s+/).length > 500){
                          setTouched({...touched,why_study:false})
                        }
                      }}
                    />
                  )}
                </Form.Group>
                {errors?.why_study && touched?.why_study && (
                  <div ref={firstErrorRef} className="error">
                    {errors?.why_study}
                  </div>
                )}
              </Col>
            </div>
            <div className={"basic_details_country"}>
              <Col sm={12}>
                <Form.Group className="mb-3" controlId="scholarship">
                  <Form.Label>Scholarship</Form.Label>
                  {(values.scholarship ||
                    values.scholarship == "undefined" ||
                    values.scholarship == "") && (
                    <CustomEditor5
                      initData={values?.scholarship}
                      onChange={(data) => {
                        setFieldValue("scholarship", data);
                        if(!values.scholarship.trim().split(/\s+/).length > 500){
                          setTouched({...touched,scholarship:false})
                        }
                      }}
                    />
                  )}
                </Form.Group>
                {errors?.scholarship && touched?.scholarship && (
                  <div ref={firstErrorRef} className="error">
                    {errors?.scholarship}
                  </div>
                )}
              </Col>
            </div>
            <div className={"basic_details_country"}>
              <Col sm={12}>
                <Form.Group className="mb-3" controlId="student_visa">
                  <Form.Label>Student Visa</Form.Label>
                  {(values.student_visa ||
                    values.student_visa == "undefined" ||
                    values.student_visa == "") && (
                    <CustomEditor5
                      initData={values?.student_visa}
                      onChange={(data) => {
                        setFieldValue("student_visa", data);
                        if(!values.student_visa.trim().split(/\s+/).length > 500){
                          setTouched({...touched,student_visa:false})
                        }
                      }}
                    />
                  )}
                </Form.Group>
                {errors?.student_visa && touched?.student_visa && (
                  <div ref={firstErrorRef} className="error">
                    {errors?.student_visa}
                  </div>
                )}
              </Col>
            </div>
            <div className={"basic_details_country"}>
              <Col>
                <Form.Group className="mb-3" controlId="lor">
                  <Form.Label>LOR</Form.Label>
                  {(values.lor ||
                    values.lor == "undefined" ||
                    values.lor == "") && (
                    <CustomEditor5
                      initData={values?.lor}
                      onChange={(data) => {
                        setFieldValue("lor", data);
                        if(!values.lor.trim().split(/\s+/).length > 500){
                          setTouched({...touched,lor:false})
                        }
                      }}
                    />
                  )}
                </Form.Group>
                {errors?.lor && touched?.lor && (
                  <div ref={firstErrorRef} className="error">
                    {errors?.lor}
                  </div>
                )}
              </Col>
            </div>
            <div className={"basic_details_country"}>
              <Col>
                <Form.Group className="mb-3" controlId="sop">
                  <Form.Label>SOP</Form.Label>
                  {(values.sop ||
                    values.sop == "undefined" ||
                    values.sop == "") && (
                    <CustomEditor5
                      initData={values?.sop}
                      onChange={(data) => {
                        setFieldValue("sop", data);
                        if(!values.sop.trim().split(/\s+/).length > 500){
                          setTouched({...touched,sop:false})
                        }
                      }}
                    />
                  )}
                </Form.Group>
                {errors?.sop && touched?.sop && (
                  <div ref={firstErrorRef} className="error">
                    {errors?.sop}
                  </div>
                )}
              </Col>
            </div>
            <div className={"basic_details_country"}>
              <Col>
                <Form.Group className="mb-3" controlId="application">
                  <Form.Label>Application details</Form.Label>
                  {(values.application ||
                    values.application == "undefined" ||
                    values.application == "") && (
                    <CustomEditor5
                      initData={values?.application}
                      onChange={(data) => {
                        setFieldValue("application", data);
                        if(!values.application.trim().split(/\s+/).length > 500){
                          setTouched({...touched,application:false})
                        }
                      }}
                    />
                  )}
                </Form.Group>
                {errors?.application && touched?.application && (
                  <div ref={firstErrorRef} className="error">
                    {errors?.application}
                  </div>
                )}
              </Col>
            </div>
            <div className={"basic_details_country"}>
              <Col>
                <Form.Group className="mb-3" controlId="document">
                  <Form.Label>Documents Required</Form.Label>
                  {(values.document ||
                    values.document == "undefined" ||
                    values.document == "") && (
                    <CustomEditor5
                      initData={values?.document}
                      onChange={(data) => {
                        setFieldValue("document", data);
                        if(!values.document.trim().split(/\s+/).length > 500){
                          setTouched({...touched,document:false})
                        }
                      }}
                    />
                  )}
                </Form.Group>
                {errors?.document && touched?.document && (
                  <div ref={firstErrorRef} className="error">
                    {errors?.document}
                  </div>
                )}
              </Col>
            </div>
            <div className={"basic_details_country"}>
              <div className={"examfilter"}>
                <h4 className={"examfilter_heading"}>Study and Work</h4>
                <Row>
                  <Col>
                    <Form.Group className="mb-3" controlId="min_wage">
                      <Form.Label>Min Wage</Form.Label>
                      <Form.Control
                        type="text"
                        name="min_wage"
                        className={"input_pd"}
                        value={values?.min_wage}
                        onBlur={handleBlur}
                        onChange={handleChange}
                      />
                    </Form.Group>
                    {errors?.min_wage && (
                      <div ref={firstErrorRef} className="error">
                        {errors?.min_wage}
                      </div>
                    )}
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="max_hours">
                      <Form.Label>Max Hours</Form.Label>
                      <Form.Control
                        type="text"
                        name="max_hours"
                        onBlur={handleBlur}
                        className={"input_pd"}
                        value={values?.max_hours}
                        onChange={handleChange}
                      />
                    </Form.Group>
                    {errors?.max_hours && (
                      <div ref={firstErrorRef} className="error">
                        {errors?.max_hours}
                      </div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group className="mb-3" controlId="part_time_work">
                      <Form.Label>Part Time Work</Form.Label>
                      {(values.part_time_work ||
                        values.part_time_work == "undefined" ||
                        values.part_time_work == "") && (
                        <CustomEditor5
                          initData={values?.part_time_work}
                          onChange={(data) => {
                            setFieldValue("part_time_work", data);
                            if(!values.part_time_work.trim().split(/\s+/).length > 500){
                              setTouched({...touched,part_time_work:false})
                            }
                          }}
                        />
                      )}
                    </Form.Group>
                    {errors?.part_time_work && touched?.part_time_work && (
                      <div ref={firstErrorRef} className="error">
                        {errors?.part_time_work}
                      </div>
                    )}
                  </Col>
                </Row>
              </div>
            </div>

            <div className={"basic_details_country"}>
              <Col sm={12}>
                <Form.Group className="mb-3" controlId="work_permit">
                  <Form.Label>Work Permit</Form.Label>
                  {(values.work_permit ||
                    values.work_permit == "undefined" ||
                    values.work_permit == "") && (
                    <CustomEditor5
                      initData={values?.work_permit}
                      onChange={(data) => {
                        setFieldValue("work_permit", data);
                        if(!values.work_permit.trim().split(/\s+/).length > 500){
                          setTouched({...touched,work_permit:false})
                        }
                      }}
                    />
                  )}
                </Form.Group>
                {errors?.work_permit && touched?.work_permit && (
                  <div ref={firstErrorRef} className="error">
                    {errors?.work_permit}
                  </div>
                )}
              </Col>
            </div>
            <div className={"domain"}>
              <div className={"examfilter"}>
                <Row>
                  {values.last_updated && (
                    <span>Last Updated date: {values.last_updated}</span>
                  )}
                </Row>
                <Row>
                  {values.updated_by && (
                    <span>Updated by: {values.updated_by} </span>
                  )}
                </Row>
              </div>
            </div>

            <Row>
              <Col className="mt-3">
                <SaveAndSaveNext
                  firstErrorRef={firstErrorRef}
                  setTouched={setTouched}
                  errors={errors}
                  setSaveAndNext={props.setSaveAndNext}
                  loading={putCountryContentDetailLoading}
                />
              </Col>
            </Row>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default ContentDetailForm;
